import { DateTime } from "luxon";
import { TripDetail } from "src/app/api/commonInterfaces";
import { WalletIncoming } from "src/app/api/types/finance";
import { TripDropdownConfiguration } from "./trip-dropdown.component";

export class TripDropdownItem {
  
    constructor(detail: TripDetail, config: TripDropdownConfiguration) {
  
      this._id = detail?.id?.toString() ?? '';
      this._groupName = detail?.groupName ?? '';
      this._location = detail?.location ?? '';
      this._tripDate = detail?.tripDate ?? new Date(1000, 0, 1);
      this._detail = detail
      this.config = config
      this.fullText = this.toString()
    }
  
    private _id = "";
    private _groupName = "";
    private _location = "";
    private _tripDate = new Date(1000, 0, 1);
    private _detail: TripDetail
    config: TripDropdownConfiguration
    fullText = ""
    
    get id() {
      return this._id
    }

    get groupName() {
      return this._groupName
    }

    get location() {
      return this._location
    }

    get tripDate() {
      return this._tripDate
    }

    get detail() {
      return this._detail
    }

    toString = (): string => {

      let parts: string[]  = []
  
      if (this.config.showLocation) {
        parts.push(this.location)
      }
  
      if (this.config.showTripDate) {
        parts.push("on " + DateTime.fromJSDate(this.tripDate).toFormat("MM/dd/yyyy"))
      }
  
      if (this.config.showGroupName) {
        parts.push(this.groupName)
      }
  
      if (this.config.showTripId) {
        parts.push("—" + this.id)
      }

      return parts.join(" ")
    }
  
  }
  